module.exports = __webpack_public_path__ + "img/scroll-down.a056ef6e.svg";